import {AppConfig} from "../../../config";
import {HttpServer} from "../../../net/http_server";
import {useSignFn} from "../../../utils/sign_fn";
import  {useCallback} from "react";
import {useWallet} from "use-wallet";

export const useClaimApply = (claim_id: number, product: string) => {
    const sign = useSignFn();
    const {account} = useWallet();
    const fatch = useCallback(async ()=>{
        let _params = claimAppleJson(claim_id, product,account);
        let _hex = await sign(_params);
        let _data = await HttpServer.claimApply(_hex,_params);
        return _data;
    },[claim_id, product,account]);

    return fatch;
}


const claimAppleJson = (claim_id: number, product: string,account:string|null): string => {
    let method = "claim_apply";

    return JSON.stringify({
        domain: {
            name: method,
            chainId: AppConfig.chainId.toString(),
        },
        message: {
            method: method,
            content: {
                user_id: account,
                claim_id: claim_id,
                product: product,
            }
        },
        primaryType: 'Place',
        types: {
            EIP712Domain: [
                {name: 'name', type: 'string'},
                {name: 'chainId', type: 'uint256'},
            ],
            Place: [
                {name: 'content', type: 'Model'},
                {name: 'method', type: 'string'},
            ],
            Model: [
                {name: 'user_id', type: 'string'},
                {name: 'claim_id', type: 'uint256'},
                {name: 'product', type: 'string'},
            ],

        }
    });
}
